import styled from "styled-components";
import { ModalFooterWrapper } from "./ModalFooterWrapper";

export const StyledModalFooterWrapper = styled(ModalFooterWrapper)`
  float: right;
  width: 180px;
  padding-right: 16px;
`;
